module.exports = __webpack_public_path__ + "img/Giving_Mobile.jpg";